import { render, staticRenderFns } from "./InsertTicket.vue?vue&type=template&id=c1bbba80"
import script from "./InsertTicket.vue?vue&type=script&lang=js"
export * from "./InsertTicket.vue?vue&type=script&lang=js"
import style0 from "./InsertTicket.vue?vue&type=style&index=0&id=c1bbba80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports